import { useSubmitContactFormMutation } from '@/rtkQuery/features/services/contactUs';

export const useContactUsService = () => {
    const [triggerSubmit, { data, error, isLoading, isSuccess, isError, status }] =
        useSubmitContactFormMutation();

    const errorMessage = (error as any)?.meta?.error || (error as any)?.data?.message || 'Something went wrong';

    return {
        contactSubmit: triggerSubmit,
        contactData: data,
        contactError: error,
        contactIsLoading: isLoading,
        contactIsSuccess: isSuccess,
        contactIsError: isError,
        contactStatus: status,
        contactErrorMessage: errorMessage,
    };
};
